import { AwsService } from './../service/aws.service';
import { VehicleService } from './../service/vehicle.service';
import { FastTrackService } from './../service/fast-track.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { VehicleLocationPcPipe } from './../pipes/vehicle-location-pc.pipe';
import { SelectPossibleOption } from './../model/search';
import { SeverityVehicleParts, Tchekb } from './../model/tchekb.model';
import { DamagesGroupedByLocation } from './../model/damage.model';
import { Component, ElementRef, HostListener, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DamageAnalysis, RoiAnalysis } from '../model/damage.model';
import { DamageService } from '../service/damage.service';
import { RoiService } from '../service/roi.service';
import * as DamageModel from '../model/damage.model';
import { ParametersService } from '../service/parameters.service';
import { flatten } from '@angular/compiler';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TraceService } from '../service/trace.service';
import { Settings } from '../model/settings.model';
import { TchekService } from '../service/tchek.service';
import { ToastService } from '../service/toast.service';
import { ReportService } from '../service/report.service';

@Component({
  selector: 'app-damage-control',
  templateUrl: './damage-control.component.html',
  styleUrls: ['./damage-control.component.less']
})
export class DamageControlComponent implements OnDestroy {

  @ViewChild('deleteModal') deleteModal: ElementRef;
  tchekId: string
  tchek: Tchekb
  damages: DamageModel.DamageControlInterface[] = []
  damageGroups: DamagesGroupedByLocation[]
  location: string
  currentRoi: RoiAnalysis
  currentDamage: DamageAnalysis;
  settings: Settings;
  possibleValuesSelectLocation: SelectPossibleOption[];
  possibleValuesSelectDelete: SelectPossibleOption[];
  possibleValuesSelectDeleteNotDamage: SelectPossibleOption[];
  openDeleteNotDamage = false
  openDeleteOther = false
  possibleValuesSelectDamage: SelectPossibleOption[];
  possibleValuesSelectSeverity: SelectPossibleOption[];
  possibleValuesSelectDamageSize: SelectPossibleOption[];
  confidence: { style: string, value: string }
  index: number = 0;
  isSuperAdmin = false
  timer: NodeJS.Timer;
  numberDamages: number;
  isOpenModal = false
  updatePage = false
  end = false
  endSimplified = false
  modalRef: NgbModalRef;
  thumbnailUrl: string
  startInspect: number = Date.now()
  otherDelete: string

  constructor(private readonly i18n: I18n,
    private modalService: NgbModal,
    private readonly _toastService: ToastService,
    private readonly _traceService: TraceService,
    private readonly _damageService: DamageService,
    private readonly _awsService: AwsService,
    private readonly _vehicleService: VehicleService,
    private readonly _routerService: Router,
    private readonly _reportService: ReportService,
    private readonly _roiService: RoiService,
    private readonly _fastTrackService: FastTrackService,
    private readonly _damageLocationPipe: VehicleLocationPcPipe,
    private readonly _parametersService: ParametersService,
    private readonly _tchekService: TchekService,
    private _route: ActivatedRoute) {

    this.isSuperAdmin = this._parametersService.isSuperAdmin

    this.settings = this._parametersService.getAll();
    if (this.settings && this.settings.accessibility && this.settings.accessibility.endOfFastTrackSimplified === true) this.endSimplified = true;
    console.log("DEBUG: DamageControlComponent constructor : this.endSimplified=",this.endSimplified);
    this.possibleValuesSelectDamageSize = this._roiService.damageSizeRange

    // get tchek id
    this._route.params.subscribe((params: Params) => {
      this.tchekId = params['id'];
      console.log('tchek id : ', this.tchekId);
      this.init()
    });

    // Populate all selectors
    this.possibleValuesSelectSeverity = this._roiService.severityOptionSelect
    this.possibleValuesSelectDamage = Object.entries(this._roiService.vehicleDamageTypes)
      .map<SelectPossibleOption>((t) => ({ key: t[0], value: t[1] }))
      .filter(opt => {
        return (opt.key !== 'added'
          && opt.key !== 'missing_part'
          && opt.key !== 'parking_sensor'
          && opt.key !== 'washer_nozzle'
        )
      })
    this.possibleValuesSelectLocation = (flatten(Object.entries(this._roiService.parts)
      .map<SelectPossibleOption[]>(p => {
        return this._roiService
          .getAllLocationPossibleVariants(p[0], p[1])
          .map<SelectPossibleOption>(l => ({
            key: l,
            value: this._damageLocationPipe.transform(l)
          }));
      }))).sort(this.compare);
    this.possibleValuesSelectDelete = [
      {
        key: 'notDamage', value: this.i18n({
          id: 'notDamage',
          value: "Ce n\'est pas un dommage",
          description: "Ce n\'est pas un dommage",
          meaning: "editModal"
        })
      },
      {
        key: 'duplicate', value: this.i18n({
          id: 'duplicate',
          value: "C\'est un doublon",
          description: "C\'est un doublon",
          meaning: "editModal"
        })
      },
      {
        key: 'notBillable', value: this.i18n({
          id: 'notBillable',
          value: "Ce n\'est pas facturable",
          description: "Ce n\'est pas facturable",
          meaning: "editModal"
        })
      },
      {
        key: 'other', value: this.i18n({
          id: 'other',
          value: "Autre",
          description: "Autre",
          meaning: "editModal"
        })
      }
    ];

    this.possibleValuesSelectDeleteNotDamage = [
      {
        key: 'sensor', value: this.i18n({
          id: 'sensor',
          value: "C\'est un capteur",
          description: "C\'est un capteur",
          meaning: "editModal"
        })
      },
      {
        key: 'water', value: this.i18n({
          id: 'water',
          value: "C\'est une trace d'eau",
          description: "C\'est une trace d'eau",
          meaning: "editModal"
        })
      },
      {
        key: 'vehicleBody', value: this.i18n({
          id: 'vehicleBody',
          value: "Forme de la carrosserie",
          description: "Forme de la carrosserie",
          meaning: "editModal"
        })
      },
      {
        key: 'reflector', value: this.i18n({
          id: 'reflector',
          value: "C\'est un Reflet",
          description: "C\'est un Reflet",
          meaning: "editModal"
        })
      },
      {
        key: 'light', value: this.i18n({
          id: 'light',
          value: "C\'est une tâche de lumière",
          description: "C\'est une tâche de lumière",
          meaning: "editModal"
        })
      },
      {
        key: 'dirt', value: this.i18n({
          id: 'dirt',
          value: "C\'est une tâche / Saleté",
          description: "C\'est une tâche / Saleté",
          meaning: "editModal"
        })
      },
      {
        key: 'other', value: this.i18n({
          id: 'other',
          value: "Autre",
          description: "Autre",
          meaning: "editModal"
        })
      }
    ];
  }

  // save traces damages and tchek
  save() {
    // save only deleted and validated or updated
    let listToSave = this.damages.filter((o: DamageModel.DamageControlInterface) => {
      return (o.damageChanges.isDeleted || o.validated)
    })

    let savingDamages = []
    let traceList: { action: string, damageId: string, data: any }[] = []
    listToSave.forEach((o: DamageModel.DamageControlInterface) => {

      /// OLD TRACE ACTION
      let actioUpdateOld = `edit damage : \
        { old : \
        { severity : ${o.originalSeverity}, \
        location : ${o.originalLocation}, \
        sizeRange : ${o.originalSize}, \
        type : ${o.originalType}},\
        new : \
        { severity : ${o.damageChanges.severity}, \
        location : ${o.damageChanges.location}, \
        sizeRange : ${o.damageChanges.sizeRange}, \
        type : ${o.damageChanges.type}}}, \
        timetoUpdate : ${o.endTime - o.startTime}`

      let action = `validate Damage `

      /// NEW TRACE DATA
      let actionUpdate = {
        type: 'validate Damage',
        data: {
          old:
          {
            severity: o.originalSeverity,
            sizeRange: o.originalSize,
            location: o.originalLocation,
            type: o.originalType
          },
          new:
          {
            severity: o.damageChanges.severity,
            location: o.damageChanges.location,
            sizeRange: o.damageChanges.sizeRange,
            type: o.damageChanges.type
          }
        },
        tool: 'fasttrak',
        timetoUpdate: o.endTime - o.startTime
      }
      let actionDelete = {
        type: 'delete damage',
        data: {
          reason: o.deleteReason
        },
        tool: 'fasttrak',
        timetoUpdate: o.endTime - o.startTime
      }
      let data = o.damageChanges.isDeleted ? actionDelete : actionUpdate

      o.damageChanges.toSync = true // sync damages
      savingDamages.push(o.damageChanges)

      if (o.originalSeverity !== o.damageChanges.severity || o.originalSize !== o.damageChanges.sizeRange
        || o.originalLocation !== o.damageChanges.location || o.originalType !== o.damageChanges.type) {
        action = actioUpdateOld
        actionUpdate.type = 'edit damage'
      }

      if (o.damageChanges.isDeleted)
        action = `Delete damage because of ${o.deleteReason.key} ${o.deleteReason.other ? o.deleteReason.other : ''} `



      traceList.push({ action: action, damageId: o.damageChanges.id, data: data })
    })
    let endTime = Date.now()
    this.tchek.toSync = true // sync tchek
    this.tchek.status = 5
    this.tchek.inspected = true
    this.tchek.damageControl = endTime - this.startInspect
    console.log('to save ', traceList, savingDamages, this.tchek)

    this._toastService.toastOpen(true);
    this._traceService.saveTraceList(this.tchekId, traceList).then(r => {
      console.log('saved traces', r)
      this._damageService.save(savingDamages).then(dl => {
        console.log('saved damages', dl)
        this._tchekService.save(this.tchek).then(tchek => {
          console.log('saved tchek', tchek)
          this._toastService.toastOpen(false);
        }).catch(err => { console.log(err) })
      }).catch(err => { console.log(err) })
    }).catch(err => { console.log(err) })
  }

  // redirect to player or report
  redirect(goTo: string) {
    if (goTo === 'player') {
      var camera = 1
      var picture = 0
      if (this.tchek && this.tchek.picturesSelected) {
        if (this.tchek.picturesSelected["thumbnail"]) {
          camera = this.tchek.picturesSelected["thumbnail"].camera
          picture = this.tchek.picturesSelected["thumbnail"].picture
        }
      }
      this._routerService
        .navigate(['player', this.tchekId, camera, picture], { queryParams: { isPercent: false } })
        .then(success => !success && console.log('Navigation failed'))
        .catch(e => console.error(e));
    } else if (goTo === 'report') {
      this._reportService.getByTchek(this.tchekId)
        .then(reports => {
          if (reports.length > 0)
            this._routerService
              .navigate(['report', reports[0].id])
              .then(success => !success && console.log('Navigation failed'))
              .catch(e => console.error(e));
          else
            this._reportService.create(this.tchekId)
              .then(report => {
                this._routerService
                  .navigate(['report', report.id])
                  .then(success => !success && console.log('Navigation failed'))
                  .catch(e => console.error(e));
              });
        });
    } else {
      this._routerService
        .navigate(['dashboard'])
        .then(success => !success && console.log('Navigation failed'))
        .catch(e => console.error(e));
    }
  }

  // Know is damage is validated or deleted
  isValidated(): boolean {
    if (this.damages[this.index].validated && this.damages[this.index].deleteReason)
      return false
    else if (this.damages[this.index].validated)
      return true
  }

  // For change Best roi
  changeBestRoi(roi, event) {
    this.stopPropagation(event)
    this.currentDamage.roiPtr = roi
  }

  
  handleDeleteDamage(reason) {
    this.damages[this.index].deleteReason = reason;
    this.damages[this.index].validated = true;
    this.damages[this.index].endTime = Date.now();
    this.currentDamage.isDeleted = true;
    this.changedamage(undefined, 'next');
  }

  // delete a damage on list
  deleteDamage() {
    console.log(">>> deleteDamage",this.settings);
    this.openDeleteNotDamage = false;
    this.openDeleteOther = false;
    this.otherDelete = '';

    // if settings require not to ask for a reason:
    if (this.settings && this.settings.accessibility && this.settings.accessibility.deleteDamageDuringFTAskReason === false) {
      this.handleDeleteDamage({ 
        key: "other",
        other: "Auto-removing since deleteDamageDuringFTAskReason settings was false for this company/user",
        value: "Autre"
      });
    } else { // otherwise we open the modal
      this.openDeleteModal().then((reason: { key: string, value: string, other: string }) => {
        this.handleDeleteDamage(reason);
      }).catch(err => console.log(err))
    }
  }

  // Validate Damage on List
  validateDamage() {
    this.damages[this.index].deleteReason = undefined
    this.damages[this.index].validated = true
    this.damages[this.index].endTime = Date.now()
    this.currentDamage.isDeleted = false
    this.changedamage(undefined, 'next')
  }

  // Show roi inside player
  handleRedirectToRoi(roi, event) {
    this.stopPropagation(event)
    this.currentRoi = roi
  }

  // change damage navigate
  changedamage(event?, where?: string) {
    this.stopPropagation(event)

    if (where === undefined && this.index === undefined) this.index = 0

    if (this.index === this.numberDamages - 1 && where === 'next') where = 'end'

    if (where === 'next' && this.index < this.numberDamages - 1) {
      if (this.damages[this.index].validated || this.currentDamage.isDeleted || this.isSuperAdmin) {
        this.index++;
      }
      else this._toastService.toastOpen(undefined, 'Merci de valider ou supprimer ce dommage pour passer au suivant.')
    }
    if (where === 'previous' && this.index > 0 && !this.end) this.index--;

    if (where === 'end') {
      this.end = true
      return;
    } else { this.end = false }

    console.log('change index', this.index)
    this.currentDamage = this.damages[this.index].damageChanges
    this.location = this.currentDamage.location || 'unknow'
    this.currentRoi = this.damages[this.index].damageChanges.listRoi[0]

    let confidence = this.currentDamage.confidence
    if (confidence === 3) this.confidence = { style: 'high', value: 'high' }
    else if (confidence === 2) this.confidence = { style: 'medium', value: 'medium' }
    else this.confidence = { style: 'low', value: 'low' }

    if (this.damages[this.index].startTime === undefined)
      this.damages[this.index].startTime = Date.now()
    console.log('currentDamageControl', this.damages[this.index]);
  }

  // get damage confidence
  getConfidence(damage: DamageAnalysis): number {
    let type = damage.type
    let level = damage.detectionCount
    let yolo = damage.roiPtr.validationScore ? damage.roiPtr.validationScore * 100 : 0
    let retina = damage.roiPtr.score ? damage.roiPtr.score * 100 : 0

    // 1 = low, 2 = medium, 3 = high
    if (type === 'bump') {
      if (level <= 3)
        if (yolo > 70 && retina > 55)
          return 3
        else if ((yolo < 40 && retina < 85) || yolo === 0)
          return 1
        else return 2
      else return 3
    } else if (type === 'scratch') {
      if (yolo > 35)
        return 2
      else return 1
    } else if (type === 'broken_part') {
      if (level > 15) return 3
      else if (level > 5) return 2
      else return 1
    } else if (type.includes('missing')) {
      if (level > 10) return 3
      else if (level > 5) return 2
      else return 1
    } else {
      if (level > 25) return 3
      else if (level < 10) return 1
      else return 2
    }
  }


  // Init get damage and rois
  async init() {
    if (this.tchekId === undefined) return
    let index = this._fastTrackService.list.findIndex(l => { return l.tchekId === this.tchekId })
    console.log('List index : ', index, this._fastTrackService.list[index]);
    if (index === -1)
      try {
        let roiList = [];

        await (await this._roiService.getTchekRois(this.tchekId, true)).forEach(roi => {
          if (roi.get('damagePtr'))
            roiList.push(new DamageModel.Roi(roi))
        });
        roiList = await Promise.all(roiList.map<Promise<RoiAnalysis>>(d => {
          return this._roiService.toRoiAnalysisObject(d);
        }))
 
        let damages = await Promise.all(
          (await this._damageService.getByTchek(this.tchekId))
            .map<Promise<DamageAnalysis>>(d => {
				
              return this._damageService.toDamageAnalysisObject(d, roiList);
            })
        );

        if (damages[0] && damages[0].tchekPtr)
          this.tchek = damages[0].tchekPtr
        else
          this.tchek = await this._tchekService.get(this.tchekId)

        let tempTchek = await this._tchekService.hydrateTchek(this.tchek.getParseInstance(), {
          includeThumbnail: true
        })

        this.thumbnailUrl = await this._awsService.generateUrlPromise(tempTchek.thumbnailUrl, tempTchek.devicePtr.ipMachine);

        this.numberDamages = 0
        damages = damages.filter(d => { return (d.isParentDamage === false && d.isAuto === true) })

        if (damages.length === 0) { this.redirect('player'); return }
        if (this.tchek.damageControl !== undefined) { this.redirect('player'); return }

        // getConfidence for damages
        console.log('filter damage confidence', this.settings.accessibility);
        damages.forEach(d => { d.confidence = this.getConfidence(d) })
        if (this.settings.accessibility) {
          let dropdamages = []
          if (this.settings.accessibility.fastTrackL1 === false)
            dropdamages = dropdamages.concat(damages.filter(d => { return d.confidence === 1 }))
          if (this.settings.accessibility.fastTrackL2 === false)
            dropdamages = dropdamages.concat(damages.filter(d => { return d.confidence === 2 }))
          if (this.settings.accessibility.fastTrackL3 === false)
            dropdamages = dropdamages.concat(damages.filter(d => { return d.confidence === 3 }))

          this._damageService.save(dropdamages).then(dl => { console.log('save drop', dropdamages); }).catch(err => { console.log(err); })
          damages = damages.filter(d => { return dropdamages.includes(d) === false })
          console.log('dropdamages bad confidence ', dropdamages, damages);
        }

        this.regroupDamages(damages)
      } catch (e) {
        console.error('Could not retrieve damages', e);
      }
    else {
      this.tchekId = this._fastTrackService.list[index].tchekId
      this.tchek = this._fastTrackService.list[index].tchek
      this.index = this._fastTrackService.list[index].index
      this.numberDamages = this._fastTrackService.list[index].numberDamages
      this.damages = this._fastTrackService.list[index].damages
      this.damageGroups = this._fastTrackService.list[index].damagesGroup
      this.changedamage()
    }
  }

  // Sort damage by CONFIDENCE on part
  async regroupDamages(damages: DamageAnalysis[]) {
    let sortArray = this._damageService.getSortArray(this.settings.report.selectorSens)

    this.damageGroups = this.damagesByGroup(damages)
    this.damageGroups.sort((a, b) => {
      let i = sortArray.findIndex(array => (array === a.svgLocation))
      let j = sortArray.findIndex(array => (array === b.svgLocation))
      if (i === -1)
        i = sortArray.length + 1;
      if (j === -1)
        j = sortArray.length + 1;
      if (i === j && i === sortArray.length + 1)
        return (sortArray.length + 1)
      return (i - j);
    })
    this.damageGroups.forEach(e => { e.damages.sort((a, b) => { return (b.confidence - a.confidence); }) });
    this.damageGroups.forEach(list => {
      list.damages.forEach(dam => {
        dam.sizeRange = dam.sizeRange ? dam.sizeRange : this.getSizeByRadius(dam.radiusWorld),
          this.damages.push({
            damageChanges: dam,
            originalSeverity: dam.severity ? dam.severity.valueOf() : undefined,
            originalSize: dam.sizeRange ? dam.sizeRange.valueOf() : undefined,
            originalType: dam.type ? dam.type.valueOf() : undefined,
            originalLocation: dam.location ? dam.location.valueOf() : undefined,
            originalBestRoiId: dam.roiPtr ? dam.roiPtr.id.valueOf() : undefined,
            endTime: undefined,
            startTime: undefined,
            deleteReason: undefined,
            validated: undefined
          })
      })
    });
    this.numberDamages = this.damages.length
    console.log(this.damages)
    this._fastTrackService.list.push({
      tchekId: this.tchekId,
      tchek: this.tchek,
      index: this.index,
      numberDamages: this.numberDamages,
      damages: this.damages,
      damagesGroup: this.damageGroups
    })
    this.changedamage()
  }

  // Change damage location
  changeLocation(event) {
    this.location = this._roiService.mapToSvgId(event.key)
  }

  // get damage size by radius
  getSizeByRadius(radius: number): string {
    radius /= 10;
    for (let index = 0; index < this._roiService.damageSizeRange.length; index++) {
      const sev = this._roiService.damageSizeRange[index];
      if (sev.range.length === 2) {
        if (radius >= sev.range[0] && radius < sev.range[1]) {
          return sev.key
        }
      } else {
        if (radius >= sev.range[0])
          return sev.key
      }
    }
  }

  // Group damages by parts
  damagesByGroup(damagesToGroup: DamageAnalysis[]): DamagesGroupedByLocation[] {
    let groupedDamages: DamagesGroupedByLocation[] = [];
    for (const damage of damagesToGroup) {
      if (damage.location && damage.location !== 'unknow')
        damage.location = this._roiService.mapToSvgId(damage.location)
      if (damage.location === 'unknow') damage.location = undefined
      let index = groupedDamages.findIndex(data => { return data.location === damage.location })
      if (index !== -1) {
        groupedDamages[index].damages.push(damage);
      } else {
        let severity: SeverityVehicleParts;
        let data = { costType: 'sum', cost: 0, severity: 'SEV0', severityType: 'sum', location: damage.location }
        severity = data
        groupedDamages.push({
          damages: [damage],
          severityPart: severity,
          newDamages: false,
          location: damage.location,
          svgLocation: damage.location
        })
      }
    }
    groupedDamages.forEach(group => {
      group.newDamages = !group.damages.every(damage => { return (damage.isParentDamage) })
    })
    return groupedDamages;
  }

  // Change Source for list roi
  changeSource(event, roi: RoiAnalysis, roiImageList) {
    var image = new Image();
    image.src = roi.bestImageUrl.hd;
    image.crossOrigin = "Anonymous";
    image.onload = function () {
      event.target.src = roi.bestImageUrl.hd
      image.crossOrigin = "Anonymous";
      roiImageList.classList.add('active');
      roiImageList.classList.remove('d-none');
    }
    image.onerror = function () {
      event.target.src = '../../../assets/icon/corrupted@3x.png'
      roiImageList.classList.add('active');
      roiImageList.classList.remove('d-none');
    }
  }

  /// Modal
  openDeleteModal() {
    return new Promise((resolve, reject) => {
      this.isOpenModal = true;
      this.modalRef = this.modalService.open(this.deleteModal, { backdropClass: 'backdropClassModal', windowClass: 'damageControlModal' });
      this.modalRef.result.then((result) => {
        this.isOpenModal = false;
        resolve(result)
      }, (reason) => {
        this.isOpenModal = false;
        let getReason
        if (reason === ModalDismissReasons.ESC) {
          getReason = 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          getReason = 'by clicking on a backdrop';
        } else {
          getReason = `with: ${reason}`;
        }
        reject(getReason)
      });
    })
  }

  saveVehicle() {
    if (this.tchek.vehiclePtr.or)
      this.tchek.vehiclePtr.or = this.tchek.vehiclePtr.or.toLocaleUpperCase();
    if (this.tchek.vehiclePtr.immat)
      this.tchek.vehiclePtr.immat = this.tchek.vehiclePtr.immat.toLocaleUpperCase();
    if (this.tchek.vehiclePtr.vin)
      this.tchek.vehiclePtr.vin = this.tchek.vehiclePtr.vin.toLocaleUpperCase();

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
    this.timer = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._vehicleService.saveVehicle(
        this.tchek.vehiclePtr.id,
        this.tchek.vehiclePtr.immat,
        this.tchek.vehiclePtr.brand,
        this.tchek.vehiclePtr.model,
        this.tchek.vehiclePtr.or,
        this.tchek.vehiclePtr.vin,
        this.tchek.vehiclePtr.class,
        this.tchek.id)
        .then(() => {
          this.timer = undefined;
          this._toastService.toastOpen(false);
        });
    }, 1000);
  }


  selectDelReason(event, reason: SelectPossibleOption, other?: string) {
    this.stopPropagation(event)
    console.log(reason);
    if (reason.key === 'notDamage') {
      this.openDeleteNotDamage = true
      return
    }

    if (reason.key === 'other' && other) {
      reason['other'] = other
    } else if (reason.key === 'other') {
      this.openDeleteOther = true
      return
    }
    this.modalRef.close(reason)
  }

  // key change damage 
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.code === 'ArrowLeft')
      this.changedamage(undefined, 'previous')
    if (event.code === 'ArrowRight')
      this.changedamage(undefined, 'next')
  }

  // Utils 
  stopPropagation(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  openComparison(tchekId: string) {
    console.log('openComparison', tchekId);
    this._roiService.setHighlightedDamage(this.currentDamage)
    this._roiService.setHighlightedRoi(this.currentRoi)
    let newRelativeUrl = this._routerService.createUrlTree(['player', this.tchekId, this.currentRoi.folder,
      this._roiService.toPicturePercent(this.currentRoi.picture, this.currentRoi.folderPtr.totalPictures)], { queryParams: { fastComp: tchekId } });
    let baseUrl = window.location.href.replace(this._routerService.url, '');

    window.open(baseUrl + newRelativeUrl, '_blank');
  }

  ngOnDestroy() {
    let index = this._fastTrackService.list.findIndex(l => { return l.tchekId === this.tchekId })
    console.log('Status :: destroy', index, this.index, this.numberDamages, this.end);
    if (this.index === this.numberDamages - 1 && this.end) {
      console.log('Status end of control :: save');
      this.save()
      this._fastTrackService.list.splice(index, 1);
    } else if (this.numberDamages === 0 && this.tchek.damageControl === undefined) {
      console.log('Status end of control :: save 0 Damages');
      this.save()
      this._fastTrackService.list.splice(index, 1);
    } else if (this.tchek.damageControl === undefined) {
      console.log('Status end of control :: add to service');
      this._fastTrackService.list[index].index = this.index
      this._fastTrackService.list[index].numberDamages = this.numberDamages
      this._fastTrackService.list[index].damages = this.damages
      this._fastTrackService.list[index].damagesGroup = this.damageGroups
    }
  }

  compare(a, b) {
    if (a.value < b.value) {
      return -1;
    }
    if (a.value > b.value) {
      return 1;
    }
    return 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/damage-control/damage-control.component.ts